import React, { useState, useRef, useEffect } from 'react';
import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';

const CustomColorPicker = (props) => {
    const [showPicker, setShowPicker] = useState(false);
    const [pickerPos, setPickerPos] = useState({ top: 0, left: 0 });
    const swatchRef = useRef(null);

    const { onChange, color, height, width } = props;

    const onClick = () => {
        if (!showPicker && swatchRef.current) {
            const rect = swatchRef.current.getBoundingClientRect();
            const pickerHeight = 300; // approximate SketchPicker height
            const pickerWidth = 220;  // approximate SketchPicker width
            const viewportH = window.innerHeight;
            const viewportW = window.innerWidth;

            // Open upward if not enough space below
            let top = rect.bottom + 4;
            if (top + pickerHeight > viewportH) {
                top = rect.top - pickerHeight - 4;
            }

            // Shift left if overflows viewport right edge
            let left = rect.left;
            if (left + pickerWidth > viewportW) {
                left = viewportW - pickerWidth - 8;
            }

            setPickerPos({ top, left });
        }
        setShowPicker((prev) => !prev);
    };

    const onClose = () => setShowPicker(false);

    // Close on scroll so it doesn't float away
    useEffect(() => {
        if (!showPicker) return;
        const handleScroll = () => setShowPicker(false);
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, [showPicker]);

    const styles = reactCSS({
        default: {
            color: {
                width: `${width || '100%'}`,
                height: `${height || '30px'}`,
                borderRadius: '3px',
                background: `${color}`
            },
            popover: {
                position: 'fixed',
                top: pickerPos.top,
                left: pickerPos.left,
                zIndex: 9999
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px'
            },
            swatch: {
                width: `${width || '100%'}`,
                padding: '6px',
                background: '#ffffff',
                borderRadius: '2px',
                cursor: 'pointer',
                display: 'inline-block',
                boxShadow: '0 0 0 1px rgba(0,0,0,.2)'
            }
        }
    });

    return (
        <div>
            <div ref={swatchRef} style={styles.swatch} onClick={onClick}>
                <div style={styles.color} />
            </div>
            {showPicker ? (
                <div style={styles.popover}>
                    <div style={styles.cover} onClick={onClose} />
                    <SketchPicker color={color || '#000000'} onChange={onChange} />
                </div>
            ) : null}
        </div>
    );
};

export default CustomColorPicker;
